import { Breadcrumb } from '@components/breadcrumb';
import { LabeledSelectBox } from '@components/labeledSelectBox';
import { useCallback, useState } from 'react';
import { useFragment } from 'react-relay';
import { TypeMap, inforServicePageFragment } from './lib';
import type { InfoServicePropsType } from './types';

export const InfoServicePage: React.FC<InfoServicePropsType> = ({ page: pageKey, currentLanguage }) => {
  const page = useFragment(inforServicePageFragment, pageKey);

  const [salesAdmission, setSalesAdmission] = useState('AT');
  const [retailOnly, setRetailOnly] = useState(true);

  const changeSalesAdmission = useCallback((newSalesAdmission: string) => {
    setSalesAdmission(newSalesAdmission);
  }, []);

  const changeRetailOnly = useCallback((newRetailOnly: string) => {
    const newValue = newRetailOnly === '1';
    setRetailOnly(newValue);
  }, []);

  return (
    <div>
      <Breadcrumb data={page.breadcrumbs} />
      <div className="relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:w-[calc(100vw-80px)] max-[1100px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]">
        <div className="flex flex-nowrap flex-col gap-2.5 mb-2.5 tablet:flex-row">
          <LabeledSelectBox labeledSelectBox={page.salesadmission} selected={salesAdmission} onChange={changeSalesAdmission} />
          <LabeledSelectBox labeledSelectBox={page.retailOnly} selected={retailOnly ? '1' : '0'} onChange={changeRetailOnly} />
        </div>
        {page.components?.edges?.map((edge) => {
          if (!edge?.node) {
            return null;
          }
          const typeConfig = TypeMap[edge.node.__typename];
          if (!typeConfig) {
            console.warn(`[InfoService] Unknown component type: ${edge.node.__typename}`);
            return null;
          }
          const Type = typeConfig[0];
          return <Type key={edge.node.__typename} component={edge.node} salesAdmission={salesAdmission} retailOnly={retailOnly} currentLanguage={currentLanguage} />;
        })}
      </div>
    </div>
  );
};
